import { library } from '@fortawesome/fontawesome-svg-core'
//import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faHtml5, faCss3Alt, faJs, faReact, 
    faJava} from '@fortawesome/free-brands-svg-icons'
library.add(faHtml5, faCss3Alt, 
        faJs, faReact, faJava);
